var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditforcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 10.0625V12.25H3.9375L10.3892 5.79829L8.20167 3.61079L1.75 10.0625ZM12.0808 4.10663C12.1349 4.05266 12.1778 3.98856 12.2071 3.91799C12.2364 3.84742 12.2514 3.77178 12.2514 3.69538C12.2514 3.61898 12.2364 3.54333 12.2071 3.47276C12.1778 3.4022 12.1349 3.33809 12.0808 3.28413L10.7158 1.91913C10.6619 1.86505 10.5978 1.82215 10.5272 1.79288C10.4566 1.7636 10.381 1.74854 10.3046 1.74854C10.2282 1.74854 10.1525 1.7636 10.082 1.79288C10.0114 1.82215 9.9473 1.86505 9.89333 1.91913L8.82583 2.98663L11.0133 5.17413L12.0808 4.10663Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditforcard);
export default __webpack_public_path__ + "static/media/editforcard.13d1d3820c86704a6a814d5b971ab42a.svg";
export { ForwardRef as ReactComponent };